import type { Config as ConfigType } from './config.types';

declare const NEXT_PUBLIC_ENVIRONMENT: string;
declare const NEXT_PUBLIC_PLATFORM_URL: string;
declare const NEXT_PUBLIC_API_URL: string;
declare const NEXT_PUBLIC_LOQATE_API_KEY: string;
declare const NEXT_PUBLIC_APP_NAME: string;
declare const NEXT_PUBLIC_SECURE_STORAGE_ENCRYPTION_KEY: string;
declare const NEXT_PUBLIC_IMAGES_URL: string;
declare const NEXT_PUBLIC_LOBBY_BACKGROUND_IMAGE_URL: string;
declare const NEXT_PUBLIC_MKODO_API_KEY: string;
declare const NEXT_PUBLIC_MKODO_CONFIG_URL: string;
declare const NEXT_PUBLIC_MKODO_ENABLED: string;
declare const NEXT_PUBLIC_SENTRY_DSN: string;
declare const NEXT_PUBLIC_BONANZA_WHEEL_URL: string;
declare const NEXT_PUBLIC_RECAPTCHA_KEY_WEB: string;
declare const NEXT_PUBLIC_APPSFLYER_CONFIG: string;
declare const NEXT_PUBLIC_SMARTICO_CONFIG: string;
declare const NEXT_PUBLIC_IOS_APP_STORE_ID: string;
declare const NEXT_PUBLIC_ANDROID_APP_STORE_ID: string;
declare const NEXT_PUBLIC_OTA_UPDATES_URL: string;
declare const NEXT_PUBLIC_ONFIDO_VERSION: string;
declare const NEXT_PUBLIC_LIVECHAT_DEFAULT_GROUP_ID: string;
declare const NEXT_PUBLIC_LIVECHAT_DEFAULT_GROUP_ID_FR: string;
declare const NEXT_PUBLIC_FIREBASE_CONFIG_WEB: string;
declare const NEXT_PUBLIC_REGISTRATION_THREE_STEP_PERCENT: string;
declare const NEXT_PUBLIC_WORLDPAY_ID: string;
declare const NEXT_PUBLIC_WORLDPAY_URL: string;
declare const NEXT_PUBLIC_ANDROID_APP_STORE_URL: string;
declare const NEXT_PUBLIC_IOS_APP_STORE_URL: string;
declare const NEXT_PUBLIC_ER_URL: string;
declare const NEXT_PUBLIC_GEOFENCE_CONFIG: string;
declare const NEXT_PUBLIC_META_PIXEL_ID: string;

export const Config: ConfigType = {
  ENVIRONMENT: String(NEXT_PUBLIC_ENVIRONMENT),
  PLATFORM_URL: String(NEXT_PUBLIC_PLATFORM_URL),
  API_URL: String(NEXT_PUBLIC_API_URL),
  LOQATE_API_KEY: String(NEXT_PUBLIC_LOQATE_API_KEY),
  APP_NAME: String(NEXT_PUBLIC_APP_NAME),
  SECURE_STORAGE_ENCRYPTION_KEY: String(
    NEXT_PUBLIC_SECURE_STORAGE_ENCRYPTION_KEY,
  ),
  IMAGES_URL: String(NEXT_PUBLIC_IMAGES_URL),
  LOBBY_BACKGROUND_IMAGE_URL: String(NEXT_PUBLIC_LOBBY_BACKGROUND_IMAGE_URL),
  MKODO_API_KEY: String(NEXT_PUBLIC_MKODO_API_KEY),
  MKODO_CONFIG_URL: String(NEXT_PUBLIC_MKODO_CONFIG_URL),
  MKODO_ENABLED: Boolean(NEXT_PUBLIC_MKODO_ENABLED === 'true'),
  SENTRY_DSN: String(NEXT_PUBLIC_SENTRY_DSN),
  BONANZA_WHEEL_URL: String(NEXT_PUBLIC_BONANZA_WHEEL_URL),
  RECAPTCHA_KEY: String(NEXT_PUBLIC_RECAPTCHA_KEY_WEB),
  APPSFLYER_CONFIG: NEXT_PUBLIC_APPSFLYER_CONFIG
    ? String(NEXT_PUBLIC_APPSFLYER_CONFIG)
    : undefined,

  SMARTICO_CONFIG: NEXT_PUBLIC_SMARTICO_CONFIG
    ? String(NEXT_PUBLIC_SMARTICO_CONFIG)
    : undefined,

  IOS_APP_STORE_ID: NEXT_PUBLIC_IOS_APP_STORE_ID
    ? String(NEXT_PUBLIC_IOS_APP_STORE_ID)
    : undefined,
  ANDROID_APP_STORE_ID: NEXT_PUBLIC_ANDROID_APP_STORE_ID
    ? String(NEXT_PUBLIC_ANDROID_APP_STORE_ID)
    : undefined,
  OTA_UPDATES_URL: String(NEXT_PUBLIC_OTA_UPDATES_URL),
  ONFIDO_VERSION: String(NEXT_PUBLIC_ONFIDO_VERSION),
  LIVECHAT_DEFAULT_GROUP_ID: String(NEXT_PUBLIC_LIVECHAT_DEFAULT_GROUP_ID),
  LIVECHAT_DEFAULT_GROUP_ID_FR: String(
    NEXT_PUBLIC_LIVECHAT_DEFAULT_GROUP_ID_FR,
  ),
  FIREBASE_CONFIG_WEB: NEXT_PUBLIC_FIREBASE_CONFIG_WEB
    ? String(NEXT_PUBLIC_FIREBASE_CONFIG_WEB)
    : undefined,
  NEXT_PUBLIC_REGISTRATION_THREE_STEP_PERCENT: String(
    NEXT_PUBLIC_REGISTRATION_THREE_STEP_PERCENT,
  ),
  WORLDPAY_ID: String(NEXT_PUBLIC_WORLDPAY_ID),
  WORLDPAY_URL: String(NEXT_PUBLIC_WORLDPAY_URL),
  ANDROID_APP_STORE_URL: String(NEXT_PUBLIC_ANDROID_APP_STORE_URL),
  IOS_APP_STORE_URL: String(NEXT_PUBLIC_IOS_APP_STORE_URL),
  ER_URL: String(NEXT_PUBLIC_ER_URL),
  GEOFENCE_CONFIG: NEXT_PUBLIC_GEOFENCE_CONFIG
    ? String(NEXT_PUBLIC_GEOFENCE_CONFIG)
    : undefined,
  META_PIXEL_ID: String(NEXT_PUBLIC_META_PIXEL_ID),
};

export default Config;
